export default __webpack_public_path__ + "static/media/intel.2a77b70b.png";